import classNames from 'classnames';
import { observer } from 'mobx-react';
import * as style from './ScoreLineShared.module.less';
export type ScoreLinePosition = 'under' | 'over' | 'in-range';

interface IScoreLineProps {
    className?: string;
    didScore?: boolean;
}
export const ScoreLineYesNo = observer((p: IScoreLineProps) => {
    const cls = classNames(style.scoreLine);

    const noCls = classNames(style.textEntry, style.tooltipRed, {
        [style.grayFilter]: p.didScore === null || p.didScore === true
    });
    const yesCls = classNames(style.textEntry, style.tooltipGreen, {
        [style.grayFilter]: p.didScore === null || p.didScore === false
    });

    const yesTooltip = (
        <div className={yesCls} style={{ left: '60%' }}>
            YES
        </div>
    );

    const noTooltip = (
        <div className={noCls} style={{ left: '40%' }}>
            NO
        </div>
    );
    const classContainer = classNames(style.scoreLineContainer, p.className);
    return (
        <>
            <div className={classContainer}>
                {yesTooltip}
                {noTooltip}
            </div>
        </>
    );
});
